import axios from "axios";
import {
  APP_API_KEY,
  INSTANCE_URL,
  LOGIN,
  REGISTER,
  FETCH_SPEAKERS,
  SELECT_FEATURE,
  TO_CHANGE_EMAIL,
} from "Constants";
import { STEP_CREATE, STEP_VERIFY, STEP_CHOOSE, STEP_FINISH } from "Signup";
import {
  SIGNUP_STEP,
  SIGNUP_FEATURE_SELECT,
  PROCEED_TO_DASHBOARD,
  RESET_ENTERED_OTP,
} from "SignupReducer";
import {
  SESSION_TOKEN,
  USER_ID,
  REGISTER_OTP,
  ADMIN_USER_ID,
  USER_EMAIL,
  ACTION_LOGOUT,
} from "Actions";
import { getHeaders } from "CommonUtils";

import { showLoading, hideLoading } from "react-redux-loading-bar";

export function registerUser(
  values,
  session,
  user,
  callback,
  method = "normal"
) {
  // debugger;

  if (session && session.sessionToken) {
    var patchUrl = `${INSTANCE_URL}/api/v2/system/user?ids=${user.userid}`;
    var resource = [
      {
        email: values.email,
      },
    ];

    var response = axios.patch(
      patchUrl,
      { resource, update_email: 1 },
      getHeaders(session)
    );
    return (dispatch) => {
      response
        .then(({ data }) => {
          dispatch({ type: USER_EMAIL, payload: values.email });
          dispatch({ type: REGISTER_OTP, payload: data.otp });
          dispatch({ type: SESSION_TOKEN, payload: { emailid: values.email } });
          dispatch({ type: SIGNUP_STEP, payload: STEP_VERIFY });
          callback({ success: 1 });
        })
        .catch((error) => {
          callback({ success: 0, message: error });
        });
    };
  } else {
    var url = `${INSTANCE_URL}/api/v2/user/register?login=true`;
    var payload = {
      email: values.email,
      new_password: values.password,
    };
    var options = {
      headers: {
        contentType: "application/json; charset=utf-8",
        "X-DreamFactory-Api-Key": APP_API_KEY,
      },
    };

    var response = axios.post(url, payload, options);

    return (dispatch) => {
      response
        .then(({ data }) => {
          var sessionToken = data.session_token;
          // save the session token generated during registration
          dispatch({ type: SESSION_TOKEN, payload: data });

          // store the OTP for verification in the next screen
          dispatch({ type: REGISTER_OTP, payload: data.otp });

          // store the email id of the user
          dispatch({ type: USER_EMAIL, payload: values.email });

          // fetch the DF user id. DF user id is not returned during registration
          // It needs to be fetched sepatately using session
          var sessionUrl = `${INSTANCE_URL}/api/v2/user/session`;
          var sessionOptions = {
            headers: {
              "X-DreamFactory-Api-Key": APP_API_KEY,
              "X-DreamFactory-Session-Token": sessionToken,
              contentType: "application/json; charset=utf-8",
            },
          };
          var sessionResponse = axios.get(sessionUrl, sessionOptions);

          sessionResponse
            .then(({ data }) => {
              // save the DF user id under the reducer user
              dispatch({ type: USER_ID, payload: data.id });

              // proceed further for OTP screen if normal, else dispatch verify with pre-login
              if (method == "normal") {
                dispatch({ type: SIGNUP_STEP, payload: STEP_VERIFY });
              } else {
                dispatch(
                  verifyCode(
                    { otp: "0000" },
                    "0000",
                    { userid: data.id },
                    { sessionToken: sessionToken, apiKey: APP_API_KEY },
                    callback
                  )
                );
              }

              callback({ success: 1 });
            })
            .catch((error) => {
              callback({ success: 0, message: error });
            });
        })
        .catch((error) => {
          callback({ success: 0, message: error });
        });
    };
  }
}

export function resetVerifyCode(reset) {
  return { type: RESET_ENTERED_OTP, payload: reset };
}

export function clearCache() {
  return { type: ACTION_LOGOUT, payload: false };
}

export function verifyCode(values, otp, user, session, callback) {
  // debugger;
  return (dispatch) => {
    // Verify OTP from the redux and OTP from values
    if (otp == values.otp) {
      var url = `${INSTANCE_URL}/api/v2/system/user/${user.userid}`;
      var payload = {
        isotpverified: 1,
      };
      var options = getHeaders(session);

      var response = axios.patch(url, payload, options);

      response
        .then(({ data }) => {
          // create an entry for the admin in the adminuser table
          var adminUrl = `${INSTANCE_URL}/api/v2/eventify/_table/adminuser`;
          var adminPayload = {
            resource: [
              {
                dfid: user.userid,
              },
            ],
          };
          var adminResponse = axios.post(adminUrl, adminPayload, options);

          adminResponse
            .then(({ data }) => {
              // store the adminuserid in redux for future use
              dispatch({
                type: ADMIN_USER_ID,
                payload: data.resource[0].userid,
              });

              // proceed to the feature choosing screen
              dispatch({ type: SIGNUP_STEP, payload: STEP_CHOOSE });
            })
            .catch((error) => {
              callback({ success: 0, message: error });
            });
        })
        .catch((error) => {
          callback({ success: 0, message: error });
        });
    } else {
      dispatch({ type: RESET_ENTERED_OTP, payload: true });
      callback({ success: 0, message: "OTP is not verified" });
    }
  };
}

export function proceedToDashboard() {
  return (dispatch) => {
    dispatch({ type: LOGIN, payload: true });
    dispatch({ type: PROCEED_TO_DASHBOARD, payload: true });
  };
}

export function resendOtp(session, callback) {
  return (dispatch) => {
    var url = `${INSTANCE_URL}/api/v2/eventifyscript/resendOTP`;
    axios
      .get(url, getHeaders(session))
      .then(({ data }) => {
        dispatch({ type: REGISTER_OTP, payload: data.otp });
        callback({ success: 1 });
      })
      .catch((error) => {
        callback({ success: 0, message: error });
      });
  };
}

export function toChangeEmail(change) {
  return (dispatch) => {
    dispatch({ type: TO_CHANGE_EMAIL, payload: change });
  };
}

export function changeEmail() {
  return (dispatch) => {
    dispatch({ type: TO_CHANGE_EMAIL, payload: true });
    dispatch({ type: "login_otp_verify", payload: true });
    dispatch({ type: SIGNUP_STEP, payload: STEP_CREATE });
  };
}

export function registerUserLinkedin(accessToken, callback) {
  var linkedInUrl = `https://api.linkedin.com/v1/people/~:(id,email-address)?format=json`;
  var headers = {
    Authorization: `Bearer ${accessToken}`,
  };

  return (dispatch) => {
    axios.get(linkedInUrl, { headers }).then(
      ({ data }) => {
        var email = data.emailAddress;
        var password = data.id;
        if (email === "") {
          callback({
            success: 0,
            message: "Email is not found. Please try another method",
          });
        } else {
          dispatch(
            registerUser({ email, password }, null, null, callback, "linkedin")
          );
        }
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export var proceedToLogin = () => ({ type: "ProceedToLogin", payload: true });
